//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

/**
 * 도급사업관리 - 평가 결과 (SUB_BASIC_02) 전용 로직
 * other 케이스에서 사용
 */

// 도급사업관리 - 평가 결과 MST 인쇄 함수
export const PrintLogic1 = async (
  documentData,
  dispatch,
  setLoading,
  rowData1,
  searchRef,
  userInfo
) => {
  if (!rowData1 || rowData1.length === 0) {
    dispatch(
      showSnackbar({
        message: '인쇄할 데이터가 없습니다.',
        type: 'warning',
      })
    );
    return null;
  }

  setLoading(true);

  try {
    const custNm =
      searchRef?.current?.custList?.find(
        (item) => item.value === searchRef?.current?.custCd
      )?.custNm || '';

    // 선택된 항목 (documentData 또는 rowData1[0])
    const selectedItem = documentData || rowData1[0];

    if (!selectedItem) {
      dispatch(
        showSnackbar({
          message: '인쇄할 항목을 선택하세요.',
          type: 'warning',
        })
      );
      return null;
    }

    let headerData = {};

    // SBM_ID로 추가 데이터 조회
    const result = await apiRequest(
      'post',
      Global.urls.DocsManagement.getSubBasicMst01R2,
      {
        SbmId: Commons.EncryptAES(String(selectedItem.sbmId || 0)),
      }
    );

    const data = result.data;

    if (data.length === 0 || data[0]?.type === 'Error') {
      dispatch(
        showSnackbar({
          message: data[0]?.message || '인쇄할 데이터가 없습니다.',
          type: 'error',
        })
      );
      return null;
    }

    const row = data[0];

    headerData = {
      gradeYear: selectedItem.sbmYear || '',
      name: userInfo.userNm || userInfo.name || '',
      updateDate: selectedItem.updateDate
        ? dayjs(selectedItem.updateDate).format('YYYY-MM-DD')
        : '',
      custNm: custNm || '',
      evaluatorOpinion: row.evaluatorOpinion || '',
      gradeFirstHalf: selectedItem.sbmHalf || '',
      score1: row.score1 || 0,
      score2: row.score2 || 0,
      score3: row.score3 || 0,
      score4: row.score4 || 0,
      score5: row.score5 || 0,
      score6: row.score6 || 0,
      score7: row.score7 || 0,
      score8: row.score8 || 0,
      score9: row.score9 || 0,
      score10: row.score10 || 0,
      deductions: row.deductions || 0,
      totalScore: row.totalScore || 0,
      grade: row.grade || 0,
    };

    // 인쇄 실행
    const printData = {
      FileName: 'SUB_BASIC_01',
      HeaderData: JSON.stringify(headerData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    return response.data; // Blob 반환
  } catch (e) {
    console.error(e);
    dispatch(
      showSnackbar({
        message: e.message || '인쇄 중 오류가 발생했습니다.',
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};

